import axios from "axios";
import userService from "./user.service";
import Toast from "../components/toast";
import { data } from "react-router-dom";

//pass new generated access token here
// let Authorization = userService.Get_Token();
// Authorization = "Bearer " + Authorization;

//apply base url for axios
const configuredApiUrl =
  process.env.REACT_APP_API_URL || "https://backend.moveinmedical.com";
  // process.env.REACT_APP_API_URL || "https://pmebackend.illusionx.co";
  // "http://localhost:5002";
  // "http://192.168.100.215:5002";
export const API_URL = configuredApiUrl.endsWith("/")
  ? configuredApiUrl
  : `${configuredApiUrl}/`;

export const getAssetUrl = (assetPath) => {
  if (!assetPath || assetPath === "null" || assetPath === "undefined") {
    return "";
  }

  if (/^(https?:|data:|blob:)/i.test(assetPath)) {
    return assetPath;
  }

  return `${API_URL}${assetPath.replace(/^\/+/, "")}`;
};

const axiosApi = axios.create({
  baseURL: API_URL + "api/",
});

// axiosApi.defaults.headers.common["Authorization"] = Authorization;

axiosApi.interceptors.request.use(
  (config) => {
    const token = userService.Get_Token();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        Toast.error("Session expired. Please log in again.");
        localStorage.clear();
        window.location.href = "/login";
      }

      return Promise.reject({
        statusCode: error.response.status,
        message: error.response.data?.message || "Request failed",
        data: error.response.data || null,
      });
    } else {
      // Toast.error("Network Error. Please check your internet connection.");

      return Promise.reject({
        statusCode: 500,
        message: "Network Error. Please check your internet connection.",
        data: null,
      });
    }
  },
);

export async function get(url, config = {}) {
  try {
    const response = await axiosApi.get(url, config);
    return response.data;
  } catch (err) {
    return err;
  }
}

export async function post(url, data, config = {}) {
  try {
    const response = await axiosApi.post(url, data, config);
    return response.data;
  } catch (err) {
    return err;
  }
}

export async function patch(url, data, config = {}) {
  try {
    const response = await axiosApi.patch(url, data, config);
    return response.data;
  } catch (err) {
    return err;
  }
}

export async function downloadFile({
  url,
  data = {},
  method = "GET",
  fileName,
  config = {},
}) {
  try {
    const response = await axiosApi({
      url,
      method,
      data,
      responseType: "blob",
      ...config,
    });

    // ⛔ Safety check
    if (!(response.status >= 200 && response.status <= 299)) {
      throw response;
    }

    // 🧠 Try to extract filename from header if not provided
    const contentDisposition = response.headers?.["content-disposition"];

    let finalFileName = fileName;

    if (!finalFileName && contentDisposition) {
      const match = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
      );
      if (match?.[1]) {
        finalFileName = match[1].replace(/['"]/g, "");
      }
    }

    // fallback filename
    if (!finalFileName) {
      finalFileName = `download-${Date.now()}.pdf`;
    }

    // ✅ FIX: response.data is already a Blob, don't wrap it again
    const blob = response.data;

    const downloadUrl = window.URL.createObjectURL(blob);

    // ⬇ Trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", finalFileName);
    document.body.appendChild(link);
    link.click();

    // 🧹 Cleanup
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return {
      success: true,
      fileName: finalFileName,
    };
  } catch (error) {
    console.error("Download failed:", error);

    return {
      success: false,
      error,
    };
  }
}

export async function openFileInNewTab({ url }) {
  window.open(
    API_URL + `api/${url}&token=${userService.Get_Token()}`,
    "_blank",
  );
}

export async function openFile({
  url,
  data = {},
  method = "GET",
  fileName,
  config = {},
}) {
  try {
    const token = userService.Get_Token();
    const response = await fetch(url, {
      method: "GET",
      headers: {
        // include auth token if your routes are protected
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || "Failed to load consent form.");
    }

    // Wait for the FULL blob to download before doing anything
    const blob = await response.blob();

    console.log(blob);

    // Verify the response is actually a PDF
    if (blob.type !== "application/pdf") {
      throw new Error("Response is not a valid PDF.");
    }

    const blobUrl = URL.createObjectURL(blob);

    // Open AFTER blob is fully ready
    window.open(blobUrl, "_blank", "noopener,noreferrer");

    // Revoke after a delay to free memory
    setTimeout(() => URL.revokeObjectURL(blobUrl), 30000);

    return null; // No error
  } catch (error) {
    console.error("Download failed:", error);
    return error.message || "An error occurred while opening the file.";
  }
}
//----------------------

export async function put(url, data, config = {}) {
  try {
    const response = await axiosApi.put(url, { ...data }, { ...config });
    return response.data;
  } catch (err) {
    return err;
  }
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
